{
  "FILTER": {
    "AI_PROMPT": "AI Filtr",
    "TITLE": "Filtrovat konverzace",
    "SUBTITLE": "Přidejte filtry níže a klikněte na 'Použít filtry' pro zpřehlednění chatů.",
    "EDIT_CUSTOM_FILTER": "Upravit složku",
    "CUSTOM_VIEWS_SUBTITLE": "Přidejte nebo odeberte filtry a aktualizujte svou složku.",
    "ADD_NEW_FILTER": "Přidat filtr",
    "FILTER_DELETE_ERROR": "Jejda, vypadá to, že nemůžeme uložit nic! Přidejte prosím alespoň jeden filtr k uložení.",
    "SUBMIT_BUTTON_LABEL": "Použít filtry",
    "UPDATE_BUTTON_LABEL": "Aktualizovat složku",
    "CANCEL_BUTTON_LABEL": "Zrušit",
    "CLEAR_BUTTON_LABEL": "Vymazat filtry",
    "FOLDER_LABEL": "Název složky",
    "TEAMS_LABEL": "Sdílet s",
    "PARENT_FOLDER_LABEL": "Nadřazená složka",
    "NO_PARENT_FOLDER": "Žádná nadřazená složka",
    "COLOR_LABEL": "Barva",
    "BACKGROUND_COLOR_LABEL": "Barva pozadí",
    "SELECT_COLOR": "Vybrat barvu",
    "CLEAR_SELECTION": "Vymazat výběr",
    "SORT_BY_LABEL": "Seřadit",
    "FOLDER_QUERY_LABEL": "Dotaz složky",
    "EMPTY_VALUE_ERROR": "Hodnota je povinná.",
    "TOOLTIP_LABEL": "Filtrovat konverzace",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "A",
      "OR": "NEBO"
    },
    "INPUT_PLACEHOLDER": "Zadejte hodnotu",
    "OPERATOR_LABELS": {
      "equal_to": "Rovná se",
      "not_equal_to": "Nerovná se",
      "does_not_contain": "Neobsahuje",
      "is_present": "Je přítomno",
      "is_not_present": "Není přítomno",
      "is_greater_than": "Je větší než",
      "is_less_than": "Je menší než",
      "is_greater_than_or_equal": "Je větší nebo rovno",
      "is_less_than_or_equal": "Je menší nebo rovno",
      "newer_than_days": "Je novější než x dnů (včetně)",
      "older_than_days": "Je starší než x dnů (včetně)",
      "starts_with": "Začíná na",
      "present": "Přítomna",
      "not_present": "Není přítomna",
      "present_with_answer": "Přítomna s vyzvednutím",
      "present_without_answer": "Přítomna bez vyzvednutí",
      "equalTo": "Rovná se",
      "notEqualTo": "Nerovno",
      "contains": "Obsahuje",
      "doesNotContain": "Neobsahuje",
      "isPresent": "Je přítomno",
      "isNotPresent": "Není přítomno",
      "isGreaterThan": "Je větší než",
      "isLessThan": "Je menší než",
      "isGreaterThanOrEqual": "Je větší nebo rovno",
      "isLessThanOrEqual": "Je menší nebo rovno",
      "startsWith": "Začíná na"
    },
    "ATTRIBUTE_LABELS": {
      "TRUE": "Pravda",
      "FALSE": "Nepravda"
    },
    "ATTRIBUTES": {
      "STATUS": "Stav",
      "ASSIGNEE_NAME": "Přiřazený agent",
      "INBOX_NAME": "Schránka",
      "TEAM_NAME": "Přiřazený tým",
      "CONVERSATION_IDENTIFIER": "Identifikátor konverzace",
      "CAMPAIGN_NAME": "Název kampaně",
      "LABELS": "Štítky",
      "BROWSER_LANGUAGE": "Jazyk prohlížeče",
      "PRIORITY": "Priorita",
      "COUNTRY_NAME": "Název země",
      "REFERER_LINK": "Odkazující odkaz",
      "CUSTOM_ATTRIBUTE_LIST": "Seznam",
      "CUSTOM_ATTRIBUTE_TEXT": "Text",
      "CUSTOM_ATTRIBUTE_NUMBER": "Číslo",
      "CUSTOM_ATTRIBUTE_LINK": "Odkaz",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Zaškrtávací pole",
      "CREATED_AT": "Vytvořeno",
      "LAST_ACTIVITY": "Poslední aktivita",
      "LAST_CUSTOMER_MESSAGE_AT": "Poslední zpráva od zákazníka",
      "PHONE_CALL": "Telefonní hovor",
      "RATING": "Hodnocení",
      "CSAT": "CSAT"
    },
    "PHONE_CALL_TYPES": {
      "INBOUND": "Příchozí",
      "OUTBOUND": "Odchozí",
      "MISSED": "Zmeškaný",
      "UNHANDLED_MISSED": "Neobsloužený zmeškaný"
    },
    "RATING_TYPES": {
      "UP": "Palec nahoru",
      "DOWN": "Palec dolů"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Hodnota je povinná",
      "ATTRIBUTE_KEY_REQUIRED": "Klíč atributu je povinný",
      "FILTER_OPERATOR_REQUIRED": "Operátor filtru je povinný",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Hodnota musí být mezi 0 a 998"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standardní filtry",
      "ADDITIONAL_FILTERS": "Další filtry",
      "CUSTOM_ATTRIBUTES": "Vlastní atributy"
    },
    "CUSTOM_VIEWS": {
      "ADD": {
        "TITLE": "Chcete uložit tento filtr?",
        "LABEL": "Pojmenujte tento filtr",
        "PLACEHOLDER": "Pojmenujte svůj filtr pro pozdější reference.",
        "ERROR_MESSAGE": "Název je povinný.",
        "SAVE_BUTTON": "Uložit filtr",
        "CANCEL_BUTTON": "Zrušit",
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Složka byla úspěšně vytvořena.",
          "ERROR_MESSAGE": "Chyba při vytváření složky."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment byl úspěšně vytvořen.",
          "ERROR_MESSAGE": "Chyba při vytváření segmentu."
        }
      },
      "EDIT": {
        "EDIT_BUTTON": "Upravit složku",
        "API_FOLDERS": {
          "ERROR_MESSAGE": "Chyba při úpravě složky."
        }
      },
      "DELETE": {
        "DELETE_BUTTON": "Smazat filtr",
        "MODAL": {
          "CONFIRM": {
            "TITLE": "Potvrdit smazání",
            "MESSAGE": "Opravdu chcete smazat filtr ",
            "YES": "Ano, smazat",
            "NO": "Ne, ponechat"
          }
        },
        "API_FOLDERS": {
          "SUCCESS_MESSAGE": "Složka byla úspěšně smazána.",
          "ERROR_MESSAGE": "Chyba při mazání složky."
        },
        "API_SEGMENTS": {
          "SUCCESS_MESSAGE": "Segment byl úspěšně smazán.",
          "ERROR_MESSAGE": "Chyba při mazání segmentu."
        }
      }
    }
  }
}
